"use client";

import { useEffect, useState } from "react";
import Link from "next/link";

interface TocItem {
  id: string;
  text: string;
  level: number;
}

export default function TableOfContents() {
  const [headings, setHeadings] = useState<TocItem[]>([]);

  useEffect(() => {
    // Get all headings with IDs
    const elements = Array.from(
      document.querySelectorAll("article h2[id], article h3[id]")
    );

    const items: TocItem[] = elements.map((elem) => ({
      id: elem.id,
      text: elem.textContent || "",
      level: parseInt(elem.tagName[1]),
    }));

    setHeadings(items);
  }, []);

  if (headings.length === 0) return null;

  return (
    <nav>
      <p className="text-base-content/50 text-sm mb-2 md:mb-3">On this page</p>
      <ul className="space-y-2 text-sm">
        {headings.map((heading) => (
          <li 
            key={heading.id}
            className={heading.level === 3 ? "ml-4" : ""}
          >
            <Link
              href={`#${heading.id}`}
              className="block py-1 transition-colors text-base-content/60 hover:text-primary"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById(heading.id)?.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }}
            >
              {heading.text}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}